module.exports = __webpack_public_path__ + "static/media/Giorno BG.adaf3463.png";